export enum HelpDeskTicketStatus {
  Pending = "pending",
  Resolved = "resolved",
}

export const HelpDeskTicketStatusTranslation = {
  [HelpDeskTicketStatus.Pending]: "Pendiente",
  [HelpDeskTicketStatus.Resolved]: "Resuelto",
};

export const HelpDeskTicketStatusBadge = {
  [HelpDeskTicketStatus.Pending]: {
    label: HelpDeskTicketStatusTranslation[HelpDeskTicketStatus.Pending],
    color: "orange",
  },

  [HelpDeskTicketStatus.Resolved]: {
    label: HelpDeskTicketStatusTranslation[HelpDeskTicketStatus.Resolved],
    color: "green",
  },
};

export enum HelpDeskResponseMethod {
  Email = "email",
  Phone = "phone",
  System = "system",
  Whatsapp = "whatsapp",
  Notification = "notification",
}

export const HelpDeskResponseMethodTranslation = {
  [HelpDeskResponseMethod.Email]: "Email",
  [HelpDeskResponseMethod.Phone]: "Teléfono",
  [HelpDeskResponseMethod.System]: "Sistema",
  [HelpDeskResponseMethod.Whatsapp]: "Whatsapp",
  [HelpDeskResponseMethod.Notification]: "Notificación",
};

export interface HelpDeskTicket {
  id: number;
  user_id: number;
  title: string;
  description?: string;
  status: HelpDeskTicketStatus;
  response?: string;
  response_method?: HelpDeskResponseMethod;
  admin_comment?: string;
  responded_by?: number;
  created_at: Date;
  updated_at: Date;
  closed_at?: Date;
}

export type CreateHelpDeskTicket = Pick<
  HelpDeskTicket,
  "title" | "description"
> & { dni?: string };

export type UpdateHelpDeskTicket = Pick<
  HelpDeskTicket,
  "status" | "response" | "response_method" | "admin_comment"
>;

export interface HelpDeskTicketWithDetails extends HelpDeskTicket {
  email: string;
  name: string;
  phone_number: string;
  responded_by_username: string;
}
